import { render } from "./ControlloConsumi.vue?vue&type=template&id=53b83ffc"
import script from "./ControlloConsumi.vue?vue&type=script&lang=js"
export * from "./ControlloConsumi.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__